<template>
    <div class="_common_fission_invite_code">
        <div class="invite-code-display" v-html="displayContent"></div>
    </div>
</template>

<script >
import { computed, onMounted, ref } from 'vue-demi';
import { VARIABLE_VALUE_MAP } from '../assets/constants';
import { replaceTemplateString } from '../assets/utils';
import Api from '../assets/scripts/request';
const __sfc_main = {};
__sfc_main.props = {
  actSign: {
    type: String,
    default: ''
  },
  module: {
    type: String,
    default: ''
  },
  inviteCodeDisplayContent: {
    type: String,
    default: '{InviteCode}'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useUser
  } = require('@fegobull/webapi').use;
  const {
    common: {
      env: {
        isPreRender
      }
    },
    store: {
      variable: {
        data
      }
    }
  } = require('@futuweb/fego-render');
  const props = __props;
  const {
    uid
  } = useUser();
  const updateFegoVariable = (key, value) => {
    data[key] = value;
  };
  const inviteCodeData = ref('');
  const inviteCodeValue = computed(() => inviteCodeData.value || '');
  const displayContent = computed(() => {
    return replaceTemplateString(props.inviteCodeDisplayContent, {
      InviteCode: inviteCodeValue.value
    });
  });
  const init = async () => {
    try {
      if (!uid || !props.actSign || !props.module) {
        return;
      }
      const {
        code
      } = await Api.getOrGenInviteCode({
        actSign: props.actSign,
        module: props.module
      });
      if (code) {
        inviteCodeData.value = code;
        updateFegoVariable(VARIABLE_VALUE_MAP.inviteCode, code);
      }
    } catch (err) {
      console.log('getOrGenInviteCode err', err);
    }
  };
  onMounted(() => {
    if (isPreRender) {
      return;
    }
    init();
  });
  return {
    displayContent
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
._common_fission_invite_code {
    width: 100%;
}
</style>
